import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { toast } from "sonner";

export default function Attachment({ api, url, att, testid }) {
  const isImg = att.type.startsWith("image/") && att.type !== "image/heic";
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!isImg) return undefined;
    let objectUrl;
    api.get(url, { responseType: "blob" })
      .then(({ data }) => { objectUrl = URL.createObjectURL(data); setSrc(objectUrl); }).catch(() => {});
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [api, url, isImg]);

  const open = async () => {
    const mobile = window.matchMedia("(pointer: coarse)").matches;
    const w = mobile ? null : window.open("", "_blank");
    try {
      const { data } = await api.get(url, { responseType: "blob" });
      const u = URL.createObjectURL(data);
      if (mobile) {
        const a = document.createElement("a");
        a.href = u;
        a.download = att.name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(u), 4000);
      } else if (w) w.location.href = u;
      else window.location.href = u;
    } catch {
      if (w) w.close();
      toast.error("Could not open the file.");
    }
  };

  if (isImg) {
    return (
      <button onClick={open} className="mt-2 block" data-testid={`${testid}-image`} aria-label={`Open ${att.name}`}>
        {src ? <img src={src} alt={att.name} className="max-h-60 max-w-full border border-[#262626] object-contain" /> : <div className="w-40 h-24 bg-[#141414] animate-pulse" />}
      </button>
    );
  }
  return (
    <button onClick={open} data-testid={`${testid}-file`}
      className="mt-2 inline-flex items-center gap-2 px-3 py-2 border border-[#262626] hover:border-white text-sm max-w-full transition-colors">
      <FileText size={15} className="text-[#FFD600] shrink-0" /> <span className="truncate">{att.name}</span>
    </button>
  );
}
